import { User } from "../../../models";
import * as type from "./constants";

export function setLoggedInUser(item: User) {
  return {
    item,
    type: type.SET_LOGGED_IN_USER
  };
}
